import { MatxLoadable } from "matx";
import { authRoles } from "../../auth/authRoles";

const Register = MatxLoadable({
    loader: () =>
        import ("./Register")
})
const AllRegister = MatxLoadable({
    loader: () =>
        import ("./AllRegister")
})




const settings = {
    activeLayout: "layout1",
    layout1Settings: {
        topbar: {
            show: false
        },
        leftSidebar: {
            show: false,
            mode: "close"
        }
    },
    layout2Settings: {
        mode: "full",
        topbar: {
            show: false
        },
        navbar: { show: false }
    },
    secondarySidebar: { show: false },
    footer: { show: false }
};

const RegisterRoutes = [
    {
        path: "/register",
        component: AllRegister,
        settings
    },

];

export default RegisterRoutes;